<!--language: Vue-->
<template>
    <div class="phonePage">
        <van-form @submit="fetchData" class="order_form">
            <Datastatisty class="select" @anyinput="oneChildClick" @anyclear="clearselect" :options="storeList"
                :type="area" :data="data"></Datastatisty>
            <Datastatisty @anyinput="oneChildClick" @anyclear="clearselect" class="select" :options="deviceList"
                :type="device" :data="dataone"></Datastatisty>
            <Dateinterval @anytime="timeselect" class="select"></Dateinterval>
            <van-button round block type="info" native-type="submit" color="#2ad1c4">查询</van-button>
        </van-form>
        <!-- 饼状图 -->
        <div ref="pieChart" id="paydata"></div>
        <!-- 数据表格 -->
        <el-card style="margin-top: 15px;" v-if="dataList">
            <!-- 综合数据 -->
            <div class="changetable" id="1" v-if="countDataList">
                <h2>综合数据</h2>
                <tablecard :countdata="countDataList"></tablecard>
            </div>
            <div class="changetable" id="2" v-if="dataList['1']">
                <h2>纪念章数据</h2>
                <tablecard :countdata="dataList['1'].total" :data="dataList['1'].detail.slice(0,50)"></tablecard>
            </div>
            <div class="changetable" id="3" v-if="dataList['2']">
                <h2>大牌数据</h2>
                <tablecard :countdata="dataList['2'].total" :data="dataList['2'].detail"></tablecard>
            </div>
        </el-card>
    </div>

</template>

<script>
import { getStoreList, getDeviceList, getdata } from "@/api/datastatistics";
import Datastatisty from './select/many.vue'
import Dateinterval from './select/date.vue'
import tablecard from "./select/nav.vue"
import sevenData from './seven.vue'
import * as echarts from "echarts";
export default {
    name: "static",
    components: {
        Datastatisty,
        Dateinterval,
        tablecard,
        sevenData
    },
    data() {
        return {
            // 复选组件
            data: {
                id: 'id',
                value: 'name',
            },
            dataone: {
                id: 'id',
                value: 'name',
            },
            gettype: '',
            gettypeseven: '',
            fullscreenLoading: false,
            typeof: true,
            type: '',
            tabledata: [], //  表格数据
            dataList: [], // 总数据
            payMapList: [], // 总支付数据
            countDataList: [], // 总类型数据
            reqForm: {
                storeIdList: [],
                deviceIdList: [],
                goodsName: '',
                page: 0,
                pageSize: 0,
                timeRange: [],
                storeId: [],
            },
            activeName: this.$store.getters.permissions, // 默认展示的是哪一个权限
            onedata: [], // 复选框传递过来得数据
            area: '景区', // 定义数据属性area，并将其赋值为"景区"
            device: '设备', // 定义数据属性area，并将其赋值为"景区"
            storeList: [], // 景区列表
            deviceList: [], // 设备列表
            optionPie: {
                tooltip: {
                    trigger: 'item',
                    formatter: '{a} <br/>{b}: {c} ({d}%)',
                },
                legend: {
                    top: '2%',
                    left: 'center',
                },
                series: [
                    {
                        name: '支付信息',
                        type: 'pie',
                        radius: ['50%', '70%'],
                        avoidLabelOverlap: false,
                        minAngle: 5, // 添加最小角度属性
                        label: {
                            show: false,
                            position: 'center',
                        },
                        emphasis: {
                            label: {
                                show: true,
                                fontSize: '30',
                                fontWeight: 'bold',
                            },
                        },
                        labelLine: {
                            show: false,
                        },
                        data: [],
                    },
                ],
            },
        }
    },
    created() {
    },
    mounted() {
        this.getAllStore()
        this.setDefaultDate()
        this.initData();
    },
    methods: {
        onSubmit() {
            console.log(this.reqForm);
        },
        // 查询数据
        async fetchData() {
            console.log(this.reqForm);
            var queryForm = this.getReq();
            console.log(queryForm);
            // if (queryForm.storeIdList.length == 0 && queryForm.deviceIdList.length == 0) {
            //   this.$message.error('请选择景区或设备');
            //   return
            // }
            getdata({
                start: queryForm.start,
                end: queryForm.end,
                company_id_list: queryForm.storeIdList,
                device_id_list: queryForm.deviceIdList
            }).then(res => {
                if (res.code === 2000) {
                    this.dataList = res.data.deviceMap
                    this.payMapList = res.data.payMapList
                    this.countDataList = res.data.totalMapList
                    let bar = this.optionPie
                    bar.series[0].data = res.data.payMapList
                    this.renderPieChart(bar)
                    // this.tabledata = res.data;
                    // this.payMapList = this.tabledata.payMapList;
                    // this.countDataList = this.tabledata.totalMapList;
                    // let bar = this.optionPie;
                    // console.log('查询出的数据', res.data);
                    // this.dataList = this.tabledata.deviceMap;
                    // this.dataList[1].detail.forEach(item => {
                    //     item.value = item.total; // 将 total 属性改为 value 属性
                    // });

                    // bar.series[0].data = this.payMapList;
                    // if (this.dataList[1].detail.length > 20) {
                    //     console.log('走到0');
                    //     bar.series[1].label.show = false
                    // } else {
                    //     console.log('走到1');
                    //     bar.series[1].label.show = true
                    // }
                    // bar.series[0].data = this.payMapList;
                    // if (this.dataList[1].detail.length < 20) {
                    //     bar.series[1].data = this.dataList[1].detail;
                    // }
                    // console.log('66', this.dataList[1].detail);
                    // console.log(this.optionPie);
                    // bar.legend.data = this.payMapList;
                    // this.renderPieChart(bar);
                }
            }).catch(err => {
                console.log(err);
            })
        },
        renderPieChart(data) {
            // this.pieChart = echarts.init(document.getElementById('piedataChart'))
            if (this.$refs.pieChart) {
                console.log(this.$refs.pieChart);
                this.pieChart = echarts.init(this.$refs.pieChart)
                this.pieChart.setOption(data)
            } else {
                console.error('Cannot find pieChart element.')
            }
        },
        // 获取景区所在设备
        async givedevice() {
            try {
                // 获取设备列表
                const deviceResponse = await getDeviceList({
                    company_id_list: this.reqForm.storeIdList
                });

                if (deviceResponse.code === 2000) {
                    if( deviceResponse.data != {} && deviceResponse.data.length > 0){
                        this.deviceList = JSON.parse(JSON.stringify(deviceResponse.data)) ; 
                    }else{
                        this.deviceList = []
                    }
                   
                }

                console.log('设备', deviceResponse.data);
            } catch (error) {
                this.$message.error(error.msg);
                console.log(error);
            }
        },
        formatDate(date) {
            // date.setDate(date.getDate() - 1); // 将日期减去一天
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        },
        setDefaultDate() {
            const today = new Date() // 获取当前时间
            today.setHours(0, 0, 0, 0) // 设置时、分、秒、毫秒为 0，即将时间设置为当天的 00:00:00.000
            const currentDate = new Date()
            currentDate.setHours(23, 59, 59, 999) // 设置时、分、秒、毫秒为最大值，即将时间设置为当天的 23:59:59.999

            this.reqForm.timeRange = [today, currentDate] // 设置当前时间范围
            console.log(this.reqForm.timeRange)
        },
        getReq() {
            var queryForm = { ...this.reqForm };
            if (this.reqForm.timeRange.length > 0) {
                const [startDate, endDate] = this.reqForm.timeRange;
                queryForm.start = this.formatDate(startDate); // 不需要调用 startDate.getTime()
                queryForm.end = this.formatDate(endDate); // 不需要调用 endDate.getTime()
            } else {
                queryForm.start = ''
                queryForm.end = ''
            }

            queryForm.storeIdList =
                queryForm.storeIdList.length > 0
                    ? queryForm.storeIdList
                    : [];

            queryForm.deviceIdList =
                queryForm.deviceIdList.length > 0
                    ? queryForm.deviceIdList
                    : [];
            return queryForm;
        },
        async initData() {
            this.loading = true;
            await this.fetchData();

            // 基于准备好的dom，初始化echarts实例
            this.chart = echarts && echarts.init(document.getElementById('paydata'));
        },
        // 传递时间组件
        timeselect(startDate, endDate) {
            const date1 = new Date(startDate)
            date1.setHours(0, 0, 0)

            const date2 = new Date(endDate)
            date2.setHours(23, 59, 59)

            this.reqForm.timeRange = [date1, date2]
            console.log(this.reqForm.timeRange);
            console.log(startDate)
            console.log(endDate)
        },
        clearselect(type) {
            console.log(type)
            if (type == '景区') {
                this.reqForm.storeIdList = []
                console.log(this.reqForm.storeIdList)
                this.givedevice()
            } else if (type == '设备') {
                this.reqForm.deviceIdList = []
            }
        },
        // 自定义方法接受子组件过来的数据
        oneChildClick(data, event) {
            console.log(data)
            console.log(event)
            if (event == '景区') {
                this.reqForm.storeIdList = []
                data.forEach((item) => {
                    this.reqForm.storeIdList.push(item.id)
                })
                this.givedevice()
            } else if (event == '设备') {
                this.reqForm.deviceIdList = []
                data.forEach((item) => {
                    this.reqForm.deviceIdList.push(item.id)
                })
            }

            //   console.log('接收到子组件数据：' + this.data);
            //   console.log('接收景区id：' + this.reqForm.storeIdList);
        },
        setDefaultDate() {
            const today = new Date() // 获取当前时间
            today.setHours(0, 0, 0, 0) // 设置时、分、秒、毫秒为 0，即将时间设置为当天的 00:00:00.000
            const currentDate = new Date()
            currentDate.setHours(23, 59, 59, 999) // 设置时、分、秒、毫秒为最大值，即将时间设置为当天的 23:59:59.999

            this.reqForm.timeRange = [today, currentDate] // 设置当前时间范围
            console.log(this.reqForm.timeRange)
        },
        async getAllStore() {
            try {
                // 获取景区列表
                const storeResponse = await getStoreList();
                if (storeResponse.code === 2000) {
                    this.storeList = storeResponse.data;
                }
                console.log(storeResponse.body);

                // 获取设备列表
                const deviceResponse = await getDeviceList();
                if (deviceResponse.code === 2000) {
                    if(deviceResponse.data!= {} && deviceResponse.data.length > 0){
                        this.deviceList = deviceResponse.data;
                    }else{
                        this.deviceList = []
                    }
                }
                console.log('设备', deviceResponse.data);
            } catch (error) {
                this.$message.error(error.msg);
                console.log(error);
            }
        }
    }
}
</script>

<style scoped>
.changetable {
    margin-top: 15px;
}

.changetable h2 {
    text-align: center;
    font-size: 16px;
    margin: 10px;
}

#paydata {
    margin-top: 15px;
    width: 100%;
    height: 400px;
    box-shadow: 0 0 15px rgba(15, 160, 222, 0.2);
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 5px;
}

.select {
    margin-top: 15px;
}

.showMoreBox {
    text-align: right;
    margin-top: 10px;
    color: #2ad1c4;
}

.order_form {
    border: 1px solid #cccccc;
    border-radius: 30px;
    padding: 20px 10px 10px 10px;
    box-shadow: 0 0 15px #8dd3ce;
    margin: 10px 0;
    font-size: 14px;
}

.listBox {
    box-shadow: 0 0 15px #8dd3ce;
    margin-bottom: 20px;
    font-size: 14px;
    padding: 10px 15px;
    /*border: 1px solid #8dd3ce;*/
    border-radius: 30px;
}

.table_row {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-bottom: 3px;
    font-size: 14px;
}

.table_row div:nth-child(1) {
    width: 100px;
    display: flex;
    flex-direction: column;
    justify-content: center;
}


.table_row div:nth-child(2) {
    width: calc(100% - 100px);
    word-break: break-all;
}


.phonePage {
    width: 90%;
    margin: 0.5em auto 0 auto;
    /*margin-top: 3.5em;*/
    padding-bottom: 3em;
    box-sizing: border-box;
}

.phonePage .van-tag {
    font-size: 14px;
}

.innerBox {
    box-shadow: 0 0 15px #ff976a;
    margin-bottom: 20px;
    font-size: 14px;
    padding: 10px 15px;
    border-radius: 30px;
    margin-top: 20px;
}

.searchBox {
    width: 90%;
    margin: 5px auto;
    border: 1px solid #8dd3ce;
    border-radius: 30px;
}

.storeBox {
    margin-bottom: 30px;
}

.noData {
    text-align: center;
    color: #8dd3ce;
    font-size: 14px;
}

.refundDesc {
    border: 1px solid #ff976a;
    border-radius: 10px;
    margin-top: 10px;
}
</style>

<style>
.van-dialog__content {
    padding: 10px 20px;
}

.van-picker-columns {
    border-top: 1px solid #8dd3ce;
}
